// raceWithTimeout.js
'use strict';

const DEFAULT_TIMEOUT_MS = 5000;

/**
 * Race a promise against a timeout. Rejects with TimeoutError if ms elapses first.
 * @param {object} params
 * @param {Promise} params.promise - The promise to race.
 * @param {number} [params.ms] - Timeout in milliseconds.
 * @param {string} params.label - Label for the timeout error message.
 * @param {Function} [params.onTimeout] - Called when timeout wins, before rejecting.
 * @returns {Promise}
 * @example
 * await raceWithTimeout({ promise: fetch(url), ms: 3000, label: 'fetch' });
 */
const raceWithTimeout = ({
  promise,
  ms = DEFAULT_TIMEOUT_MS,
  label,
  onTimeout,
}) => {
  let timeoutId;
  const timeout = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      onTimeout?.();
      const error = new Error(`${label} timeout after ${ms}ms`);
      error.name = 'TimeoutError';
      reject(error);
    }, ms);
  });
  return Promise.race([promise, timeout]).finally(() =>
    clearTimeout(timeoutId)
  );
};

export default raceWithTimeout;
